// ** Navigation imports
import Dashboard from './Dashboard';
import ModulePages from './ModulePages';
import Setup from './Setup';
import Table from './Table';

// ** Merge & Export
export default [...Dashboard, ...Table, ...ModulePages, ...Setup];
